import { BaseApi, Environment } from '@nextroll/ar-base-api';
import { CrmOptionType } from 'types/rofl';


const contactredemptionApi = new BaseApi('/zeta/v1/contactredemption/', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

export const getContactsByFilterCount = async (
    advertisableEid?: string,
    crm?: CrmOptionType,
    maxPerAccount?: number,
    body?: any,
    signal?: AbortSignal,
) => {
    if (!advertisableEid || !crm || !body) {
        return undefined; // data is not ready; do nothing
    }
    return (await contactredemptionApi.post(
        'count',
        {
            advertisable_eid: advertisableEid,
            crm,
            ...(maxPerAccount !== undefined ? { max_per_account: maxPerAccount } : {}), // optional
        },
        body,
        signal,
    ) as { count: number; cost: number });
};

export const getCreditInfo = async (advertisableEid?: string, signal?: AbortSignal,) => {
    if (!advertisableEid) {
        return undefined; // missing advertisable; do nothing
    }
    return await contactredemptionApi.get('credits', { advertisable_eid: advertisableEid }, signal) as {
        allotted_credits: number;
        used_credits: number;
        overage_allowed: boolean;
    };
};

/**
 * when the contact engagement checkbox is selected in the contact filters,
 * we want to insert the following chunk in the contact redemption request body
 */
export const CONTACT_REDEMPTION_ACTIVITY_QUERY = {
    activity_query: {
        list_rule: {
            rule_type: 'OR',
            rules: [
                {
                    attribute_rule_index: 0,
                    rule_type: 'attribute',
                    source: 'dll',
                    object: '',
                    operator: 'in_range',
                    attribute_name: 'dll__rw_cli',
                    display_name: 'Ad Clicks',
                    type: 'sum',
                    multivalued: false,
                    from: 1,
                    join_by_contact: true,
                    event_type: 'cli',
                    event_type_column: 'event_type',
                    since: 'P30D'
                },
                {
                    attribute_rule_index: 1,
                    rule_type: 'attribute',
                    source: 'dll',
                    object: '',
                    operator: 'in_range',
                    attribute_name: 'dll__rw_page_views',
                    display_name: 'Page Views',
                    type: 'sum',
                    multivalued: false,
                    from: 1,
                    join_by_contact: true,
                    event_type: 'page_view',
                    event_type_column: 'event_type',
                    since: 'P30D'
                }
            ]
        }
    }
};

export default contactredemptionApi;
